function checkCartDrawerCurrency() {
  const prices = document.querySelectorAll(
    'cart-drawer-items .cart-item__final-price .money'
  );

  if (!prices.length) return;

  const needsConversion = Array.from(prices).some(
    el => !el.classList.contains('hw-currency')
  );

  if (!needsConversion) return;

  clearTimeout(window._hwCurrencyTimer);

  window._hwCurrencyTimer = setTimeout(() => {
    if (typeof window.hwCurrencyConverterLoad === 'function') {
      window.hwCurrencyConverterLoad();
    }
  }, 1000);
}

async function getUsergeo() {
    const t = await fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json?country[enabled]=true`),
        e = await t.json();
    if (e?.detected_values?.country?.handle) return e.detected_values.country.handle
}
class CartRemoveButton extends HTMLElement {
    constructor() {
        super(), this.addEventListener("click", t => {
            t.preventDefault();
            const e = this.closest("cart-items") || this.closest("cart-drawer-items"),
                r = Number(this.dataset.index);
            !r || r < 1 ? console.error("Invalid cart line index:", this.dataset.index) : e.updateQuantity(r, 0)
        })
    }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
    constructor() {
        super(), this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");
        const t = debounce(t => {
            this.onChange(t)
        }, ON_CHANGE_DEBOUNCE_TIMER);
        this.addEventListener("change", t.bind(this))
    }
    cartUpdateUnsubscriber = void 0;
    connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, t => {
            "cart-items" !== t.source && this.onCartUpdate()
        }), this.checkAndToggleShipping()
    }
    disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber()
    }
    resetQuantityInput(t) {
        const e = this.querySelector(`#Quantity-${t}`);
        e.value = e.getAttribute("value"), this.isEnterPressed = !1
    }
    setValidity(t, e, r) {
        t.target.setCustomValidity(r), t.target.reportValidity(), this.resetQuantityInput(e), t.target.select()
    }
    validateQuantity(t) {
        const e = parseInt(t.target.value),
            r = t.target.dataset.index;
        let n = "";
        e < t.target.dataset.min ? n = window.quickOrderListStrings.min_error.replace("[min]", t.target.dataset.min) : e > parseInt(t.target.max) ? n = window.quickOrderListStrings.max_error.replace("[max]", t.target.max) : e % parseInt(t.target.step) !== 0 && (n = window.quickOrderListStrings.step_error.replace("[step]", t.target.step)), n ? this.setValidity(t, r, n) : (t.target.setCustomValidity(""), t.target.reportValidity(), this.updateQuantity(r, e, document.activeElement.getAttribute("name"), t.target.dataset.quantityVariantId))
    }
    onChange(t) {
        this.validateQuantity(t)
    }
    checkAndToggleShipping() {
        getUsergeo().then(t => {
            const e = document.querySelectorAll("#Cart__Shipping");
            "AE" == t ? e.forEach(t => {
                t.style.display = "block"
            }) : e.forEach(t => {
                t.style.display = "none"
            })
        })
    }
    onCartUpdate() {
        "CART-DRAWER-ITEMS" === this.tagName ? fetch(`${routes.cart_url}?section_id=cart-drawer`).then(t => t.text()).then(t => {
            const e = (new DOMParser).parseFromString(t, "text/html"),
                r = ["cart-drawer-items", ".cart-drawer__footer"];
            for (const t of r) {
                const r = document.querySelector(t),
                    n = e.querySelector(t);
                r && n && r.replaceWith(n)
            }
            this.checkAndToggleShipping();
            checkCartDrawerCurrency();
        }).catch(t => {
            console.error(t)
        }) : fetch(`${routes.cart_url}?section_id=main-cart-items`).then(t => t.text()).then(t => {
            const e = (new DOMParser).parseFromString(t, "text/html").querySelector("cart-items");
            this.innerHTML = e.innerHTML, this.checkAndToggleShipping()
        }).catch(t => {
            console.error(t)
        })
    }
    getSectionsToRender() {
        return [{
            id: "main-cart-items",
            section: document.getElementById("main-cart-items").dataset.id,
            selector: ".js-contents"
        }, {
            id: "main-cart-footer",
            section: document.getElementById("main-cart-footer").dataset.id,
            selector: ".js-contents"
        }, {
            id: "cart-live-region-text",
            section: "cart-live-region-text",
            selector: ".shopify-section"
        }, {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section"
        }]
    }
    updateQuantity(t, e, r, n) {
        if (!(t = Number(t)) || t < 1) return void console.error("updateQuantity called with invalid line:", t);
        this.enableLoading(t);
        const i = JSON.stringify({
            line: t,
            quantity: e,
            sections: this.getSectionsToRender().map(t => t.section),
            sections_url: window.location.pathname
        });
        fetch(`${routes.cart_change_url}`, {
            ...fetchConfig(),
            body: i
        }).then(t => t.text()).then(e => {
            const i = JSON.parse(e),
                a = document.getElementById(`Quantity-${t}`) || document.getElementById(`Drawer-quantity-${t}`),
                s = document.querySelectorAll(".cart-item");
            0 === i.item_count ? document.querySelectorAll(".cart-count-bubble").forEach(t => {
                t.style.display = "none"
            }) : document.querySelectorAll(".cart-count-bubble").forEach(t => {
                t.style.display = "flex"
            });
            if (document.querySelectorAll(".hw__cart-count").forEach(t => {
                    t.textContent = i.item_count
                }), i.errors) return a.value = a.getAttribute("value"), void this.updateLiveRegions(t, i.errors);
            this.classList.toggle("is-empty", 0 === i.item_count);
            const o = document.querySelector("cart-drawer"),
                c = document.getElementById("main-cart-footer");
            c && c.classList.toggle("is-empty", 0 === i.item_count), o && o.classList.toggle("is-empty", 0 === i.item_count), this.getSectionsToRender().forEach(t => {
                (document.getElementById(t.id).querySelector(t.selector) || document.getElementById(t.id)).innerHTML = this.getSectionInnerHTML(i.sections[t.section], t.selector)
            });
            const d = i.items[t - 1] ? i.items[t - 1].quantity : void 0;
            let l = "";
            s.length === i.items.length && d !== parseInt(a.value) && (l = void 0 === d ? window.cartStrings.error : window.cartStrings.quantityError.replace("[quantity]", d)), this.updateLiveRegions(t, l);
            const u = document.getElementById(`CartItem-${t}`) || document.getElementById(`CartDrawer-Item-${t}`);
            u && u.querySelector(`[name="${r}"]`) ? o ? trapFocus(o, u.querySelector(`[name="${r}"]`)) : u.querySelector(`[name="${r}"]`).focus() : 0 === i.item_count && o ? trapFocus(o.querySelector(".drawer__inner-empty"), o.querySelector("a")) : document.querySelector(".cart-item") && o && trapFocus(o, document.querySelector(".cart-item__name")), publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "cart-items",
                cartData: i,
                variantId: n
            })
        }).catch(() => {
            this.querySelectorAll(".loading__spinner").forEach(t => t.classList.add("hidden"));
            const t = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
            t && (t.textContent = window.cartStrings.error)
        }).finally(() => {
            this.disableLoading(t), this.checkAndToggleShipping(), window?.bindUpsellAddToCartButtons()
        })
    }
    updateLiveRegions(t, e) {
        const r = document.getElementById(`Line-item-error-${t}`) || document.getElementById(`CartDrawer-LineItemError-${t}`);
        r && (r.querySelector(".cart-item__error-text").textContent = e), this.lineItemStatusElement.setAttribute("aria-hidden", !0);
        const n = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
        n.setAttribute("aria-hidden", !1), setTimeout(() => {
            n.setAttribute("aria-hidden", !0)
        }, 1e3)
    }
    getSectionInnerHTML(t, e) {
        return (new DOMParser).parseFromString(t, "text/html").querySelector(e).innerHTML
    }
    enableLoading(t) {
        (document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems")).classList.add("cart__items--disabled");
        [...this.querySelectorAll(`#CartItem-${t} .loading__spinner`), ...this.querySelectorAll(`#CartDrawer-Item-${t} .loading__spinner`)].forEach(t => t.classList.remove("hidden")), document.activeElement.blur(), this.lineItemStatusElement.setAttribute("aria-hidden", !1)
    }
    disableLoading(t) {
        const e = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        e && e.classList.remove("cart__items--disabled");
        const r = this.querySelectorAll(`#CartItem-${t} .loading__spinner`),
            n = this.querySelectorAll(`#CartDrawer-Item-${t} .loading__spinner`);
        r.forEach(t => t.classList.add("hidden")), n.forEach(t => t.classList.add("hidden"))
    }
}
customElements.define("cart-items", CartItems), customElements.get("cart-note") || customElements.define("cart-note", class extends HTMLElement {
    constructor() {
        super(), this.addEventListener("input", debounce(t => {
            const e = JSON.stringify({
                note: t.target.value
            });
            fetch(`${routes.cart_update_url}`, {
                ...fetchConfig(),
                body: e
            })
        }, ON_CHANGE_DEBOUNCE_TIMER))
    }
});